// extracted by mini-css-extract-plugin
module.exports = {"search":"PositionsWidget_search__ZEXh5","productCol":"PositionsWidget_productCol__2LQgC"};